module.exports = __webpack_public_path__ + "470c43c2b42a23fbc9a39c5175694e46.woff2";